import { defineAsyncComponent, markRaw } from 'vue'

export function getCashBoxModal() {
  return markRaw(defineAsyncComponent(() => import('@cashbox/CashBoxModal.vue')))
}

export function getAuthModal() {
  return markRaw(defineAsyncComponent(() => import('components/modals/AuthModal.vue')))
}

export function getCashBackModal() {
  return markRaw(defineAsyncComponent(() => import('components/modals/CashBackModal.vue')))
}

export function getAuthSocialAdditionalInfoComponent() {
  return markRaw(defineAsyncComponent(() => import('@auth/AuthSocialAdditionalInfo.vue')))
}

export const getMobNavigatorComponent = () => {
  return markRaw(defineAsyncComponent(() => import('components/layouts/mob-nav/MobNav.vue')))
}
